<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="isActive">Is Active</label>
                    <wj-combo-box
                        id="isActive"
                        [(ngModel)]="target.isActive"
                        name="isActive"
                        [itemsSource]="boolMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="dayOfWeek">Day of Week</label>
                    <wj-combo-box
                        id="dayOfWeek"
                        [(ngModel)]="target.dayOfWeek"
                        name="dayOfWeek"
                        [itemsSource]="dayOfWeekList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="txbxshortName">Name</label>
                    <input id="txbxName" type="text" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="usersSelector">Attendees</label>
                    <wj-list-box
                        #usersSelector
                        class="form-control"
                        style="height: 300px; padding: 0"
                        [itemsSource]="users"
                        [displayMemberPath]="'displayName'"
                        [checkedMemberPath]="'checked'"
                    ></wj-list-box>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
